module.exports = "<p>\n  signout works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/authentication/signout/signout.component.html
// module id = ../../../../../src/app/authentication/signout/signout.component.html
// module chunks = main